import { authServiceApi } from "../../../../app/authServiceApi";
import { API_URL } from "../../../../constants/apiUrl";
import { CommonResponse, GetQueryArgsType } from "../../../../types";
import {
  AllSalarySlabParams,
  AllSalarySlabResponse,
  SingleSalarySlabResponse,
} from "./salarySlab.type";

export const salarySlabApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // ------ Mutations ------
    createSalarySlab: builder.mutation({
      query: (data) => ({
        url: API_URL.createSalarySlab,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetSalarySlab"];
        return [];
      },
    }),

    updateSalarySlab: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.updateSalarySlab}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _error, arg) => {
        if (result) {
          return ["GetSalarySlab", { type: "GetSalarySlab", id: arg.id }];
        }
        return [];
      },
    }),

    // ------ Queries ------
    getAllSalarySlab: builder.query<
      CommonResponse<AllSalarySlabResponse>,
      GetQueryArgsType<AllSalarySlabParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllSalarySlab,
        ...queryArgs,
      }),
      providesTags: ["GetSalarySlab"],
    }),

    getSingleSalarySlab: builder.query<
      CommonResponse<SingleSalarySlabResponse>,
      number
    >({
      query: (id) => ({
        url: `${API_URL.getSingleSalarySlab}/${id}`,
      }),
      providesTags: (_result, _error, id) => [{ type: "GetSalarySlab", id }],
    }),
  }),
});

export const {
  // ------ Mutation Hooks ------
  useCreateSalarySlabMutation,
  useUpdateSalarySlabMutation,

  // ------ Query Hooks ------
  useGetAllSalarySlabQuery,
  useGetSingleSalarySlabQuery,
} = salarySlabApi;
